<template>
  <loading-logo v-if="isFetching" />
  <main v-else>
    <section>
      <div>
        <h4 class="body-bold-base neutral-20-dark--text">
          {{ $t('message.pages.drm.drmLevelSecurity.title') }}
        </h4>
        <h5 class="body-regular-smaller neutral-40-light--text">
          {{ $t('message.pages.drm.drmLevelSecurity.description') }}
        </h5>
        <a
          type="secondary"
          size="xsmall"
          target="_blank"
          :href="$t('message.pages.drm.drmWatermark.howToUseHref')"
        >
          {{ $t('message.embedModal.knowMoreInArticle') }}
          <v-icon size="11px">mdi-open-in-new</v-icon></a
        >
      </div>
      <div
        class="d-flex flex-column justify-space-between align-center section-content"
      >
        <div
          class="d-flex justify-space-between neutral-100-white w-100"
          :class="{
            'flex-column': isMobileBreakpoint,
            'align-center': !isMobileBreakpoint,
          }"
          style="
            padding-top: 10px;
            padding-bottom: 10px;
            padding-left: 16px;
            padding-right: 16px;
            border-top-left-radius: 8px;
            border-top-right-radius: 8px;
          "
        >
          <span class="body-regular-small neutral-20-dark--text">
            {{
              $t('message.pages.drm.drmLevelSecurity.selectedLevelSecurity')
            }}</span
          >
          <v-chip-group
            v-model="security_type"
            show-arrows
            @change="changePreview"
          >
            <v-chip
              :class="{
                'v-chip--active': security_type == 0,
              }"
              style="margin-right: 0px !important"
              @click="selectedDrmGroup.security_type = 'regular'"
            >
              Regular
            </v-chip>

            <v-chip
              :class="{
                'v-chip--active': security_type !== 0,
              }"
              min-width="115px"
              class="ml-3 custom-chip"
              @click="selectedDrmGroup.security_type = 'advance'"
            >
              {{ $t('message.pages.drm.drmLevelSecurity.advanced') }}
            </v-chip>
          </v-chip-group>
        </div>
        <div
          class="d-flex justify-space-between"
          style="padding: 24px; width: 100%"
          :style="{ gap: isMobileBreakpoint ? '20px' : '' }"
          v-if="security_type == 1"
          :class="{
            'flex-column': isMobileBreakpoint,
            'align-center': !isMobileBreakpoint,
          }"
        >
          <img :src="require('@/assets/panda-drm-advance.png')" />
          <div :style="{ width: isMobileBreakpoint ? '100%' : '50%' }">
            <h4 class="body-bold-base neutral-20-dark--text">
              {{ $t('message.pages.drm.drmLevelSecurity.textsAdvanced.title') }}
            </h4>
            <h5 class="d-flex body-regular-smaller neutral-20-dark--text my-4">
              <v-icon size="16" class="brand-30-darker--text mr-1"
                >panda-security-on</v-icon
              >
              {{ $t('message.pages.drm.drmLevelSecurity.textsAdvanced.text1') }}
            </h5>
            <h5 class="d-flex body-regular-smaller neutral-20-dark--text my-4">
              <v-icon size="16" class="brand-30-darker--text mr-1"
                >panda-security-on</v-icon
              >
              {{ $t('message.pages.drm.drmLevelSecurity.textsAdvanced.text2') }}
            </h5>
            <h5 class="d-flex body-regular-smaller neutral-20-dark--text my-4">
              <v-icon size="16" class="brand-30-darker--text mr-1"
                >panda-security-on</v-icon
              >
              {{
                userPlanInfo.currency !== 'usd'
                  ? $t('message.pages.drm.drmLevelSecurity.textsAdvanced.text3')
                  : $t(
                      'message.pages.drm.drmLevelSecurity.textsAdvanced.text3US'
                    )
              }}
            </h5>
          </div>
        </div>
        <div
          class="d-flex justify-space-between"
          style="padding: 24px; width: 100%"
          :style="{ gap: isMobileBreakpoint ? '20px' : '' }"
          :class="{
            'flex-column': isMobileBreakpoint,
            'align-center': !isMobileBreakpoint,
          }"
          v-else
        >
          <img :src="require('@/assets/panda-drm-regular.png')" />
          <div :style="{ width: isMobileBreakpoint ? '100%' : '50%' }">
            <h4 class="body-bold-base neutral-20-dark--text mr-1">
              {{ $t('message.pages.drm.drmLevelSecurity.textsRegular.title') }}
            </h4>
            <h5 class="d-flex body-regular-smaller neutral-20-dark--text my-4">
              <v-icon size="16" class="brand-30-darker--text"
                >panda-security-on</v-icon
              >
              {{ $t('message.pages.drm.drmLevelSecurity.textsRegular.text1') }}
            </h5>
            <h5 class="d-flex body-regular-smaller neutral-20-dark--text my-4">
              <v-icon size="16" class="brand-30-darker--text mr-1"
                >panda-security-on</v-icon
              >{{ $t('message.pages.drm.drmLevelSecurity.textsRegular.text2') }}
            </h5>
            <h5 class="d-flex body-regular-smaller neutral-20-dark--text my-4">
              <v-icon size="16" class="brand-30-darker--text mr-1"
                >panda-security-on</v-icon
              >
              {{ $t('message.pages.drm.drmLevelSecurity.textsRegular.text3') }}
            </h5>
          </div>
        </div>
      </div>
      <div
        v-if="security_type == 1"
        class="d-flex justify-space-between align-center my-4"
      >
        <div class="d-flex flex-column" style="width: 40%">
          <span class="body-regular-small neutral-20-dark--text"
            >{{
              $t('message.pages.drm.drmLevelSecurity.selectedDuration')
            }} </span
          ><span class="body-regular-smaller neutral-40-light--text">{{
            $t('message.pages.drm.drmLevelSecurity.selectedDurationDescription')
          }}</span>
        </div>
        <div style="width: 50%">
          <v-select
            :menu-props="{ top: false, offsetY: true }"
            v-model="security_level"
            :items="durations"
            item-text="label"
            item-value="value"
            placeholder="Seleciona uma opção"
            hide-details
            @change="changePreview"
          />
        </div>
      </div>
      <div class="d-flex justify-space-between align-center my-4">
        <div class="d-flex flex-column" style="width: 40%">
          <span class="body-regular-small neutral-20-dark--text"
            >{{ $t('message.pages.drm.drmLevelSecurity.selectedAnimation') }}
            <v-tooltip bottom
              ><template v-slot:activator="{ on, attrs }"
                ><v-icon v-bind="attrs" v-on="on" left small
                  >panda-info-solid</v-icon
                ></template
              ><span>{{
                animation_type == 'default'
                  ? $t('message.pages.drm.drmLevelSecurity.tooltipDefault')
                  : $t('message.pages.drm.drmLevelSecurity.tooltipDynamic')
              }}</span></v-tooltip
            >
          </span>
          <span class="body-regular-smaller neutral-40-light--text">{{
            $t(
              'message.pages.drm.drmLevelSecurity.selectedAnimationDescription'
            )
          }}</span>
        </div>
        <div style="width: 50%">
          <v-select
            v-model="animation_type"
            :menu-props="{ top: false, offsetY: true }"
            :items="animationTypes"
            item-text="label"
            item-value="value"
            placeholder="Seleciona uma opção"
            hide-details
            @change="changeTypeAnimation"
          />
        </div>
      </div>
    </section>
  </main>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
import drmApi from '@/services/drmApi'
import LoadingLogo from '../../../components/LoadingLogo.vue'
import i18n from '@/translations/lang'
export default {
  name: 'DrmWatermark',
  components: { LoadingLogo },
  props: {
    selectedDrmGroup: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      durations: [
        {
          label: i18n.t('message.pages.drm.optionsDuration.low'),
          value: 'low',
        },
        {
          label: i18n.t('message.pages.drm.optionsDuration.medium'),
          value: 'medium',
        },
        {
          label: i18n.t('message.pages.drm.optionsDuration.high'),
          value: 'high',
        },
      ],
      animationTypes: [
        {
          label: i18n.t('message.pages.drm.optionsMoviment.default'),
          value: 'default',
        },
        {
          label: i18n.t('message.pages.drm.optionsMoviment.dynamic'),
          value: 'dynamic',
        },
      ],
      security_type: this.selectedDrmGroup.security_type == 'regular' ? 0 : 1,
      security_level: this.selectedDrmGroup.security_level || 'high',
      animation_type:
        this.selectedDrmGroup.config['animation-type'] || 'dynamic',
      isFetching: false,
    }
  },
  computed: {
    ...mapState({
      profile: (state) => state.video.profile,
      isMobileBreakpoint: (state) => state.user.isMobileBreakpoint,
      isTabletBreakpoint: (state) => state.user.isTabletBreakpoint,
      userPlanInfo: (state) => state.user.userPlanInfo,
    }),
  },
  methods: {
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    changeTypeAnimation() {
      const positionMode = this.animation_type == 'dynamic' ? 9 : 4
      this.$root.$emit('change-type-animation', positionMode)
      this.changePreview()
    },
    changePreview() {
      this.selectedDrmGroup.security_type = this.security_type
      this.selectedDrmGroup.security_level = this.security_level
      if (!this.selectedDrmGroup.security_level && !this.security_level)
        this.security_level = 'high'
      this.selectedDrmGroup.config['animation-type'] = this.animation_type
      this.$root.$emit('changePreview', this.selectedDrmGroup)
    },
    async handleEdit() {
      this.isFetching = true
      this.$root.$emit('isBtnloading', true)
      const body = {
        security_level: this.security_level,
        security_type: this.security_type,
        'animation-type': this.animation_type,
      }
      if (this.security_type == 1) {
        body.security_type = 'advanced'
        body.security_level = this.security_level
      }
      if (this.security_type == 0) {
        body.security_type = 'regular'
        delete body.security_level
      }

      try {
        let ret = await drmApi.drmUpdateVideos(this.selectedDrmGroup.id, body)
        this.isFetching = false
        this.$root.$emit('updateDrmGroup', ret.data)
        this.$root.$emit('updateDrmGroupStart', ret.data)
        this.UPDATE_GLOBAL_SNACKBAR({
          open: true,
          type: 'success',
          text: this.$t('message.pages.drm.drmApparence.tooltip'),
        })
        this.$root.$emit('isBtnloading', false)
      } catch (e) {
        this.isFetching = false
        console.log('e', e)
        this.$root.$emit('isBtnloading', false)
      }
    },
  },
  mounted() {
    this.$root.$on('publish-level-security-tab', () => {
      this.handleEdit()
    })
    this.$root.$on('discard-changes', (selectedDrmGroup) => {
      this.security_type = selectedDrmGroup.security_type == 'regular' ? 0 : 1
      this.security_level = selectedDrmGroup.security_level
      if (!this.selectedDrmGroup.security_level) this.security_level = 'high'
      this.animation_type = selectedDrmGroup.config['animation-type']
    })
    this.$root.$on('changeLanguage', () => {
      this.animationTypes = [
        {
          label: this.$t('message.pages.drm.optionsMoviment.default'),
          value: 'default',
        },
        {
          label: this.$t('message.pages.drm.optionsMoviment.dynamic'),
          value: 'dynamic',
        },
      ]
      this.durations = [
        {
          label: i18n.t('message.pages.drm.optionsDuration.low'),
          value: 'low',
        },
        {
          label: i18n.t('message.pages.drm.optionsDuration.medium'),
          value: 'medium',
        },
        {
          label: i18n.t('message.pages.drm.optionsDuration.high'),
          value: 'high',
        },
      ]
    })
    if (!this.selectedDrmGroup.security_level) this.security_level = 'high'

    const createdAt = new Date(this.selectedDrmGroup.created_at)
    const cutoffDate = new Date('2025-06-19T00:00:00Z')
    if (
      !this.selectedDrmGroup.config['animation-type'] &&
      createdAt < cutoffDate
    ) {
      this.animation_type = 'default'
    }
  },
  beforeDestroy() {
    this.$root.$off('publish-level-security-tab')
  },
}
</script>
<style lang="scss" scoped>
.w-100 {
  width: 100%;
}
.brand-30-darker--text {
  color: varFigma(brand-30-darker);
}
.section-content {
  margin-top: 24px;
  border-radius: 8px;
  border: 1px solid varFigma(brand-95-lighter);
  background: varFigma(brand-99-lightest);
}
</style>
